module.exports = __webpack_public_path__ + "img/Phone_03.6dbe8d2f.jpg";